module.exports = __webpack_public_path__ + "static/media/view.ad70960c.svg";